<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/GXS7gC/tc-custom/9781429986670.jpg?1740715144961" alt="This image is the cover for the book Red Dragon Rising: Shock of War, Red Dragon Rising"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Red Dragon Rising: Shock of War, Red Dragon Rising
      </h1>
      <p class="bookDescription body article font2">
        <b><i>New York Times</i>–Bestselling Authors: Two US soldiers confront Chinese tanks in a covert fight to stop a global war between East and West . . . </b><br/><br/>Under secret orders from the president, US Army Major Zeus Murphy sabotages a Chinese invasion fleet on the eve of its assault against Vietnam. But after Murphy and fellow officer Win Christian are trapped behind enemy lines, Christian’s erratic behavior gives them away. The pair shoot their way out of a Chinese airport terminal, hijack a bus, then barely escape two truckloads of soldiers before disappearing into the night.<br/><br/>Back in America, President Chester Greene fails to convince Congress that the Chinese invasion of Vietnam is the first step in a plan to rule Asia—and eventually go to war with the US. Not even the Pentagon will support the President; top-ranking officers do everything they can to sabotage his orders.<br/><br/>After Zeus and Christian dodge a Chinese armored division and return to Vietnam, Zeus proposes a plan to blunt the tank attack. His commanding officer orders him to stand down. Zeus disobeys in an effort to help the Vietnamese woman he’s fallen in love with. Win Christian goes with him to prove he’s not a coward. And within hours, both men are alone with a company of Vietnamese soldiers on the border, staring down the barrels of Chinese main battle tanks as they drive on Haiphong, starting a countdown to all-out war with the West . . . <br/><br/>“Ratchet[s] up the action . . . Readers will root for Murphy.” —<i>Publishers Weekly</i><br/><br/>“Crackling action and splendid heroics.” —<i>Kirkus Reviews</i><br/><br/>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Larry Bond, Jim DeFelice
      </h2>
      
      <p class="authorDescription body article"><P>LARRY BOND is the author of numerous <I>New York Times </I>bestselling thrillers, including <I>Cold Choices, Vortex, Cauldron</I>, and <I>The Enemy Within.</I> He previously worked with Jim DeFelice on the <I>Larry Bond's First Team </I>series. A former Naval Intelligence officer, warfare analyst and anti-submarine technology expert, he makes his home in Springfield, Virginia.<br>JIM DeFELICE is the author of many military thrillers and is a frequent collaborator with Stephen Coonts, Larry Bond, and Richard Marcinko, among other <I>New York Times</I> bestselling authors. His solo novels include <I>Leopards Kill,</I><I>Threat Level Black</I>, <I>Coyote Bird</I>, <I>War Breaker</I>, and <I>My Brother's Keeper</I>. He lives in New York.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Tom Doherty Associates
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1ac88366